import React, { useState } from 'react';
import { useHistory } from 'react-router-dom';
import iconError from '../../../../../../assets/icons/illustration.svg';
import { Block, Text, Icon } from '@/presentation/components';
import ContentModalOneButton from '../../../components/ContentModalOneButton';
import ModalConfirmation from '../../../components/Modal/Modal';
import Spinner from '../../../../../components/Spinner';
import { SubContainer } from '../../certificates-constancies/type1/info/components';
import {
  TextTitle,
  ToggleHeader
} from '../../certificates-constancies/type1/register/components';
import ConfirmationQuit from '../UpdatePhoto/Register/components/ConfirmationQuit';
import Processing from '@/presentation/components/Processing';
import Step from '../UpdatePhoto/Register/components/Step';
import ReusableTitle from '@/presentation/reusables/Title';
import ReusablePin from '@/presentation/reusables/Pin';
import ReusableCard from '@/presentation/reusables/Card';
import CustomFilter from '@/presentation/components/Filter';
import ReusableButton from '@/presentation/reusables/Button';
import { GoToPhotoComponent } from './views/Info';
import ModuleContainer from '@/presentation/components/Container';
import Back from '@/presentation/reusables/Button/Back';

interface CertificateOfStudiesRegisterViewProps {
  procedureSelectedInfo: any;
  upDatePeriods?: any;
  onSelectedPeriods: any;
  selectedPeriods: any;
  onRegisterPeriod: () => void;
  isProcessing: boolean;
  isRegisterError: boolean;
  handlerErrorClose: (newValue: boolean) => void;
  acadProg?: string;
  loadingPeriods?: boolean;
}

const CertificateOfStudiesRegisterView = (
  props: CertificateOfStudiesRegisterViewProps
) => {
  const history = useHistory();
  const [showAlertBack, setShowAlertBack] = useState(false);
  const {
    procedureSelectedInfo,
    upDatePeriods,
    onSelectedPeriods,
    selectedPeriods,
    onRegisterPeriod,
    isProcessing,
    isRegisterError,
    handlerErrorClose,
    acadProg,
    loadingPeriods
  } = props;
  const goBack = () => {
    if (selectedPeriods) {
      setShowAlertBack(true);
      return;
    }
    history.goBack();
  };
  const selectPeriodos = (e: any) => {
    onSelectedPeriods(
      e
        .filter((s: any) => s.isSelected)
        ?.map((s: any) => s.value)
        ?.join('-')
    );
  };

  return (
    <ModuleContainer
      containerType="subsection"
      data-testid="cmp-CertificateOfStudiesRegisterView"
    >
      <div style={{ paddingTop: 16, paddingBottom: 12 }}>
        <Back dataTestid="cmp-buttom-back-refactor" onClick={goBack} />
      </div>
      {loadingPeriods ? (
        <Spinner />
      ) : (
        <SubContainer>
          <ToggleHeader
            name={'Certificado de estudios'}
            amount={procedureSelectedInfo?.amount}
            duration={procedureSelectedInfo?.duration}
            date={procedureSelectedInfo?.endDate}
            perPeriod
            childContent={
              <>
                <ReusableTitle
                  fontSize="14px"
                  fontWeight="700"
                  lineHeight="20px"
                  title="¿Qué requisito necesito?"
                />
                <GoToPhotoComponent url="/tramites/autogestionables/registro-foto" />
                <ReusablePin
                  message={procedureSelectedInfo?.pin1}
                  style={{ marginTop: '16px' }}
                />
              </>
            }
          />
          <TextTitle title="Progreso" color="#283044" />
          <Block customized padding="28px 0px 45px 8px">
            <Step
              name={procedureSelectedInfo?.steps[0]?.name}
              order={procedureSelectedInfo?.steps[0]?.order}
              isCurrent
            >
              <ReusableCard
                style={{
                  display: 'flex',
                  flexDirection: 'column',
                  marginBottom: 24,
                  marginTop: 24,
                  gap: 8
                }}
                padding="24px 24px 24px 24px"
              >
                <p style={{ marginBottom: '8px' }}>
                  <span
                    style={{
                      fontWeight: 700,
                      fontSize: '14px',
                      lineHeight: '20px'
                    }}
                  >
                    Carrera:
                  </span>{' '}
                  {acadProg}
                </p>
                <p
                  style={{
                    fontWeight: 700,
                    fontSize: '14px',
                    lineHeight: '20px'
                  }}
                >
                  Ciclo
                </p>
                {upDatePeriods?.find(
                  (period: any) => period.isDisabled === true
                ) && (
                  <Block
                    customized
                    flexDirection="row"
                    alignItems="flex-start"
                    borderRadius="8px"
                    maxWidth="100%"
                    backgroundColor="#D5E5F0"
                    padding="16px 16px 16px 24px"
                    style={{ gap: 8 }}
                  >
                    <Icon name="info" size={20} />
                    <Text
                      color="#161D1F"
                      fontSize="14px"
                      lineHeight="20px"
                      fontWeight="400"
                      witdh="100%"
                    >
                      Los ciclos con deuda pendiente no podrán seleccionarse.
                    </Text>
                  </Block>
                )}
                <CustomFilter
                  onChange={(t: any) => {
                    selectPeriodos(t);
                  }}
                  placeholder="Selecciona los ciclos"
                  choices={upDatePeriods?.map((e: any) => ({
                    label: e.description,
                    value: e.id,
                    isDisabled: e.isDisabled
                  }))}
                />
                <ReusableButton
                  disabled={!selectedPeriods}
                  text="Siguiente"
                  onClick={onRegisterPeriod}
                />
              </ReusableCard>
            </Step>
            <Step
              name={procedureSelectedInfo?.steps[1]?.name}
              order={procedureSelectedInfo?.steps[1]?.order}
              disabled
            />
            <Step
              name={procedureSelectedInfo?.steps[2]?.name}
              order={procedureSelectedInfo?.steps[2]?.order}
              disabled
              isLast
            />
          </Block>
        </SubContainer>
      )}
      <Processing isOpen={isProcessing} />

      <ModalConfirmation
        show={showAlertBack}
        handleClose={() => {
          setShowAlertBack(false);
        }}
      >
        <ConfirmationQuit
          handleQuit={() => history.goBack()}
          handleCancel={() => setShowAlertBack(false)}
        />
      </ModalConfirmation>

      <ModalConfirmation
        show={isRegisterError}
        handleClose={() => handlerErrorClose(false)}
      >
        <ContentModalOneButton
          img={iconError}
          title="¡Oh no!<br/>Ha sucedido un error inesperado"
          showInfo={false}
          textButton="Entendido"
          onClickButton={() => handlerErrorClose(false)}
          style={{ textAlign: 'center', color: 'var(--text-text02)' }}
        />
      </ModalConfirmation>
    </ModuleContainer>
  );
};

export default CertificateOfStudiesRegisterView;
